import useCoreModelsFind from 'hooks/useCoreModelsFind'
import { useSelector } from 'react-redux'
import { selectCurrentRegion } from '../../ducks/region'

export default regionMetadataId => {
  const region = useSelector(selectCurrentRegion)
  return useCoreModelsFind('regionMetadata', regionMetadataId || region.regionMetadataId)
}
